export const favoritePotions = [{
    "name": "Argonian",
    "weight": 0.7,
    "value": 38,
    "effects": ["Restore Fatigue", "Swift Swim", "Water Breathing"],
    "positiveEffectCount": 3,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Scrib Jerky",
        "effects": ["Restore Fatigue", "Fortify Fatigue", "Burden", "Swift Swim"],
        "value": 5,
        "weight": 0.2
    }, {
        "name": "Scales",
        "effects": ["Drain Personality", "Water Walking", "Restore Endurance", "Swift Swim"],
        "value": 2,
        "weight": 0.2
    }, {
        "name": "Hackle-Lo Leaf",
        "effects": ["Restore Fatigue", "Paralyze", "Water Breathing", "Restore Luck"],
        "value": 30,
        "weight": 0.1
    }, {
        "name": "Luminous Russula",
        "effects": ["Water Breathing", "Drain Fatigue", "Poison"],
        "value": 1,
        "weight": 0.2
    }]
}, {
    "name": "Marathoner",
    "weight": 0.4,
    "value": 16,
    "effects": ["Restore Fatigue", "Fortify Fatigue", "Feather"],
    "positiveEffectCount": 3,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Scuttle",
        "effects": ["Restore Fatigue", "Fortify Fatigue", "Feather", "Telekinesis"],
        "value": 10,
        "weight": 0.1
    }, {
        "name": "Heather",
        "effects": ["Restore Personality", "Feather", "Drain Speed", "Drain Personality"],
        "value": 1,
        "weight": 0.1
    }, {
        "name": "Scrib Jerky",
        "effects": ["Restore Fatigue", "Fortify Fatigue", "Burden", "Swift Swim"],
        "value": 5,
        "weight": 0.2
    }]
}, {
    "name": "Sprinter",
    "weight": 0.5,
    "value": 310,
    "effects": ["Feather", "Fortify Speed"],
    "positiveEffectCount": 2,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Scuttle",
        "effects": ["Restore Fatigue", "Fortify Fatigue", "Feather", "Telekinesis"],
        "value": 10,
        "weight": 0.1
    }, {
        "name": "Moon Sugar",
        "effects": ["Fortify Speed", "Dispel", "Drain Endurance", "Drain Luck"],
        "value": 50,
        "weight": 0.1
    }, {
        "name": "Shalk Resin",
        "effects": ["Drain Fatigue", "Fortify Health", "Drain Personality", "Fortify Speed"],
        "value": 50,
        "weight": 0.1
    }, {
        "name": "Ruby",
        "effects": ["Drain Health", "Feather", "Restore Intelligence", "Drain Agility"],
        "value": 200,
        "weight": 0.2
    }]
}, {
    "name": "Roids",
    "weight": 1,
    "value": 311,
    "effects": ["Feather", "Fortify Strength"],
    "positiveEffectCount": 2,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Scuttle",
        "effects": ["Restore Fatigue", "Fortify Fatigue", "Feather", "Telekinesis"],
        "value": 10,
        "weight": 0.1
    }, {
        "name": "Ruby",
        "effects": ["Drain Health", "Feather", "Restore Intelligence", "Drain Agility"],
        "value": 200,
        "weight": 0.2
    }, {
        "name": "Dreugh Wax",
        "effects": ["Fortify Strength", "Restore Strength", "Drain Luck", "Drain Willpower"],
        "value": 100,
        "weight": 0.2
    }, {
        "name": "Ash Yam",
        "effects": ["Fortify Intelligence", "Fortify Strength", "Resist Common Disease", "Detect Key"],
        "value": 1,
        "weight": 0.5
    }]
}, {
    "name": "Oh shit",
    "weight": 2.4,
    "value": 203,
    "effects": ["Restore Fatigue", "Fortify Health", "Fortify Magicka", "Restore Health"],
    "positiveEffectCount": 4,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Large Kwama Egg",
        "effects": ["Restore Fatigue", "Paralyze", "Frost Shield", "Fortify Health"],
        "value": 2,
        "weight": 2
    }, {
        "name": "Shalk Resin",
        "effects": ["Drain Fatigue", "Fortify Health", "Drain Personality", "Fortify Speed"],
        "value": 50,
        "weight": 0.1
    }, {
        "name": "Saltrice",
        "effects": ["Restore Fatigue", "Fortify Magicka", "Drain Strength", "Restore Health"],
        "value": 1,
        "weight": 0.1
    }, {
        "name": "Emerald",
        "effects": ["Fortify Magicka", "Restore Health", "Drain Agility", "Drain Endurance"],
        "value": 150,
        "weight": 0.2
    }]
}, {
    "name": "The force",
    "weight": 0.4,
    "value": 79,
    "effects": ["Fortify Magicka", "Restore Magicka"],
    "positiveEffectCount": 2,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Saltrice",
        "effects": ["Restore Fatigue", "Fortify Magicka", "Drain Strength", "Restore Health"],
        "value": 1,
        "weight": 0.1
    }, {
        "name": "Comberry",
        "effects": ["Drain Fatigue", "Restore Magicka", "Fire Shield", "Reflect"],
        "value": 2,
        "weight": 0.1
    }, {
        "name": "Frost Salts",
        "effects": ["Drain Speed", "Restore Magicka", "Frost Shield", "Resist Fire"],
        "value": 75,
        "weight": 0.1
    }, {
        "name": "Stoneflower Petals",
        "effects": ["Restore Strength", "Fortify Magicka", "Drain Luck", "Fortify Personality"],
        "value": 1,
        "weight": 0.1
    }]
}, {
    "name": "Alchemists morning",
    "weight": 2.6,
    "value": 12,
    "effects": ["Fortify Intelligence", "Cure Paralyzation", "Fortify Luck", "Fortify Endurance"],
    "positiveEffectCount": 4,
    "alchemyProficiency": 4,
    "ingredients": [{
        "name": "Ash Yam",
        "effects": ["Fortify Intelligence", "Fortify Strength", "Resist Common Disease", "Detect Key"],
        "value": 1,
        "weight": 0.5
    }, {
        "name": "Corkbulb Root",
        "effects": ["Cure Paralyzation", "Restore Health", "Lightning Shield", "Fortify Luck"],
        "value": 5,
        "weight": 0.1
    }, {
        "name": "Guar Hide",
        "effects": ["Drain Fatigue", "Fortify Endurance", "Restore Personality", "Fortify Luck"],
        "value": 5,
        "weight": 1
    }, {
        "name": "Netch Leather",
        "effects": ["Fortify Endurance", "Fortify Intelligence", "Drain Personality", "Cure Paralyzation"],
        "value": 1,
        "weight": 1
    }]
}]